import { Injectable } from '@angular/core';
import { CustomHttpClient } from './custom-http-client.service';
import { HttpParams } from '@angular/common/http';
import { UpdoxUser } from '../routes/practices/updox-integration/updox-user';

@Injectable({
  providedIn: 'root'
})
export class UpdoxService {
  constructor(private http: CustomHttpClient) {}

  getUpdoxUser(practiceId: number): Promise<any> {
    let params = new HttpParams().set('practice_id', String(practiceId));
    return this.http.get('updox/get_updox_users', { params }).toPromise();
  }

  saveUser(updoxUser: UpdoxUser): Promise<any> {
    return this.http.post('updox/save_user', updoxUser.to_params()).toPromise();
  }

  updateUser(updoxUser: UpdoxUser): Promise<any> {
     return this.http.post('updox/save_user', updoxUser.to_params()).toPromise();
  }
}
